import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import { connect, initColyseus } from './socket';

export default class GameInst {
  constructor() {
    document
      .querySelector('#gameInst_btn')
      .addEventListener('click', this.onGameInst_btn.bind(this));
  }

  init() {
    this.isChecked = true;
    this.canProceed = false;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.animations();
    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  animations() {
    let k = 0;
    const percentage = 100 / 31;
    const int = setInterval(() => {
      document.querySelector('.mobileIcon').style.backgroundPosition = `50% ${
        k * percentage
      }%`;
      k++;
      if (k === 32) {
        // clearInterval(int);
        k = 0;
      }
    }, 100);

    let k1 = 0;
    const percentage1 = 100 / 12;
    const int1 = setInterval(() => {
      document.querySelector('.tapIcon').style.backgroundPosition = `50% ${
        k1 * percentage1
      }%`;
      k1++;
      if (k1 === 13) {
        k1 = 0;
      }
    }, 100);
    let k2 = 0;
    const percentage2 = 100 / 13;
    const int2 = setInterval(() => {
      document.querySelector('.timeIcon').style.backgroundPosition = `50% ${
        k2 * percentage2
      }%`;
      k2++;
      if (k2 === 14) {
        k2 = 0;
      }
    }, 100);
  }

  showScreen(screenKey) {
    if (screenKey != 'GameInst') return false;

    document.querySelector('.lookAround').innerHTML = `${
      Global.language[`lookAround${Global.collectableType}`][Global.lang]
    }`;
    this.pageAnimation();
    this.canProceed = true;
    document.querySelector('#gameInstr_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#gameInst_btn', { opacity: 0 });
    gsap.fromTo(
      '#gameInstr_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );

    setTimeout(() => {
      setTimeout(() => {
        this.events.dispatchEvent({
          type: 'ANIMATION_EVENTS',
          message: {
            event_type: 'buttonAnimation',
            data: {
              selector: '#gameInst_btn',
            },
          },
        });
      }, 1000);
    }, 500);
  }

  hideControls() {}

  onPlay() {
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'Home',
        },
      },
    });
  }

  async onGameInst_btn() {
    if (!this.canProceed) return false;

    Global.clickUpdater('gameInst_btn');
    this.canProceed = false;

    document.querySelector('#gameInstr_scr').classList.remove('active');
    document.querySelector('.cookie_container .cookie_info .cookie img').src =
      Global.collectableType == 'chocolate'
        ? '/assets/UI/dark-chocolate---Leaderboard.png'
        : '/assets/UI/Hazelnut---Leaderboard.png';
    document.querySelector('.cookie_container .inside').innerHTML = `${
      Global.language[`lookAround${Global.collectableType}`][Global.lang]
    }`;
    if (Global.isMultiplayer && Global.playerIndex == 1) {
      this.events.dispatchEvent({
        type: 'LOADER_EVENTS',
        message: {
          event_type: 'switch_page',
          data: {
            screenKey: 'QRScanner',
          },
        },
      });
    } else if (Global.isMultiplayer && Global.playerIndex == 2) {
      initColyseus();
      const connectStatus = await connect();
      if (connectStatus == 'failure') {
        alert('URL is either expired/invalid!');
      } else {
      }
    } else if (!Global.isMultiplayer && Global.playerIndex == 1) {
      Global.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_game',
          data: {},
        },
      });
    }
    // this.events.dispatchEvent({
    //   type: 'LOADER_EVENTS',
    //   message: {
    //     event_type: 'switch_page',
    //     data: {
    //       screenKey: 'Score',
    //     },
    //   },
    // });
  }

  onOkay() {
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector('#instr_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
